export const pluralise = (noun: string, count: number) =>
    count !== 1 ? `${noun}s` : noun;

export const formatNumber = (number: number | string): [string, number] => {
    const strno = `${number}`.replace(/[^.\d]/, "");
    const parts = strno.split(".");
    if (strno.indexOf(".") !== -1 && parseInt(parts[1]) > 0) {
        const f = parseFloat(strno);
        return [
            f.toLocaleString("en", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }),
            f
        ];
    } else {
        const i = parseInt(strno);
        return [i.toLocaleString("en"), i];
    }
};

export const formatRate = (number: number | string) =>
    (Math.round(parseFloat(`${number}`) * 10) / 10).toFixed(2);
